<div class="d-flex flex-column justify-content-center h-100">
  <img id="unauthorize-image" class="align-self-center" src="/assets/images/set-logo.png" width="100" height="100">
  <br>
  <div class="text-center">
      <h1 id="unauthorize-title-text">Session Timeout</h1>
  </div>
  <div id="unauthorize-text" class="text-center">
      Your session has expired. Because you haven't use it for long time.
  </div>
</div>